import React, { Component, Fragment } from 'react'
import { Modal, Button, Col, Spin } from 'hljd'
import { observer } from 'mobx-react'
import LayoutRow from '@common/LayoutRow'
import store from '../../store'
import style from './style.module.less'
import {
  INVOICE_DETAIL_STATUS,
  INVOICE_KIND,
  DETAIL_STATUS_COLOR
} from '@constant'
import { getMoney } from '@hlj/hlj-utils'

const layout = [4, 16]

@observer
export default class extends Component {
  render() {
    const { detailModalVisible, closeDetailModal, record, modalLoading } = store
    const {
      trade_no,
      kind,
      refuse_content,
      invoice_kind,
      title,
      identifier,
      images,
      money,
      created_at,
      status,
      phone,
      email,
      bank,
      bank_no,
      address,
      contact_mobile,
      shop_address
    } = record

    return (
      <Modal
        title="发票详情"
        visible={detailModalVisible}
        onCancel={closeDetailModal}
        footer={
          <Button type="primary" onClick={closeDetailModal}>
            知道了
          </Button>
        }
        width={800}
      >
        <Spin spinning={modalLoading}>
          <div className={style.content}>
            <div className={style.infoTop}>
              <LayoutRow {...layout} className={style.row}>
                <Col className={style.label}>订单号：</Col>
                <Col>{trade_no}</Col>
              </LayoutRow>

              <LayoutRow {...layout} className={style.row}>
                <Col className={style.label}>发票类型：</Col>
                <Col>{INVOICE_KIND[invoice_kind + '']}</Col>
              </LayoutRow>

              <LayoutRow {...layout} className={style.row}>
                <Col className={style.label}>发票抬头：</Col>
                <Col>{title}</Col>
              </LayoutRow>

              {kind == 2 && (
                <Fragment>
                  <LayoutRow {...layout} className={style.row}>
                    <Col className={style.label}>纳税人识别号：</Col>
                    <Col>{identifier}</Col>
                  </LayoutRow>

                  {invoice_kind == 2 && (
                    <Fragment>
                      <LayoutRow {...layout} className={style.row}>
                        <Col className={style.label}>合同照片：</Col>
                        <Col>
                          {(images || []).map(({ img }, index) => (
                            <img
                              key={index}
                              src={img}
                              style={{
                                width: 78,
                                height: 78,
                                marginRight: 20,
                                marginBottom: 20,
                                cursor: 'pointer'
                              }}
                              onClick={() => window.open(img)}
                            />
                          ))}
                        </Col>
                      </LayoutRow>

                      <LayoutRow {...layout} className={style.row}>
                        <Col className={style.label}>注册场所地址：</Col>
                        <Col>{address}</Col>
                      </LayoutRow>

                      <LayoutRow {...layout} className={style.row}>
                        <Col className={style.label}>注册固定电话：</Col>
                        <Col>{contact_mobile}</Col>
                      </LayoutRow>

                      <LayoutRow {...layout} className={style.row}>
                        <Col className={style.label}>开户银行名称：</Col>
                        <Col>{bank}</Col>
                      </LayoutRow>

                      <LayoutRow {...layout} className={style.row}>
                        <Col className={style.label}>开户银行卡号：</Col>
                        <Col>{bank_no}</Col>
                      </LayoutRow>
                    </Fragment>
                  )}
                </Fragment>
              )}

              <LayoutRow {...layout} className={style.row}>
                <Col className={style.label}>开票金额：</Col>
                <Col>{getMoney(money)}</Col>
              </LayoutRow>

              <LayoutRow {...layout} className={style.row}>
                <Col className={style.label}>申请时间：</Col>
                <Col>{created_at}</Col>
              </LayoutRow>

              <LayoutRow {...layout} className={style.row}>
                <Col className={style.label}>状态：</Col>
                <Col>
                  <span style={{ color: DETAIL_STATUS_COLOR[status + ''] }}>
                    {INVOICE_DETAIL_STATUS[status + '']}
                  </span>
                </Col>
              </LayoutRow>

              {status == 2 && (
                <LayoutRow {...layout} className={style.row}>
                  <Col className={style.label}>原因：</Col>
                  <Col>{refuse_content}</Col>
                </LayoutRow>
              )}
            </div>

            <div className={style.infoBottom}>
              <LayoutRow {...layout} className={style.row}>
                <Col className={style.label}>收票人手机：</Col>
                <Col>{phone}</Col>
              </LayoutRow>

              {invoice_kind == 1 && (
                <LayoutRow {...layout} className={style.row}>
                  <Col className={style.label}>收票邮箱：</Col>
                  <Col>{email}</Col>
                </LayoutRow>
              )}

              {invoice_kind == 2 && (
                <LayoutRow {...layout} className={style.row}>
                  <Col className={style.label}>收票地址：</Col>
                  <Col>{shop_address}</Col>
                </LayoutRow>
              )}
            </div>
          </div>
        </Spin>
      </Modal>
    )
  }
}
